'use client';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { debounce } from '@/utils/debounce';
import { particles } from '@/utils/particles';
import CTA from '@/components/ui/CTA';
import More from '@/icons/icon-more.svg';
import '@/styles/components/library/intro.css';

const Intro = ({ headline, text, cta }) => {
  const stage = useRef(null);

  useEffect(() => {
    const container = stage.current;
    if (!container) return;

    const handleResize = debounce(() => {
      particles(container);
    }, 300);

    particles(container);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      container.innerHTML = '';
    };
  }, []);

  return (
    <section id="intro" className="intro">
      <div className="intro__content">
        <div className="intro__main">
          <h1 className='intro__headline'>{headline}</h1>
          <p className="intro__text">{text}</p>

          <CTA type="link" text={cta} url="/contact" />
        </div>
      </div>

      <Image
        src={More.src}
        width={40}
        height={40}
        alt="Learn more icon"
        className="intro__more"
      />
      <div className="intro__stage" ref={stage} />
    </section>
  );
}

export default Intro;
